<template>
  <div class="post" id="print-post">
    <div :class="`tonal-indicator  ${getTonalClass(post)}`"></div>
    <post-header :post="post">
      <div class="post-controls">
        <a class="to-print" @click="printPost">
          Печать
        </a>
        <a class="to-original" target="_blank" :href="post.uri">
          Оригинал
        </a>
      </div>
    </post-header>

    <post-body :post="post" />
    <div class="post-footer">

      <div class="post-comments" v-if="post.comments !== '0'">
        <div class="post-comments-count">
          <span class="post-comments-count__count">{{ post.comments }} {{declOfNum(parseInt(post.comments))}}</span>
        </div>
      </div>

      <template v-if="commentaries[post.id]">
        <post-comment v-for="comment in commentaries[post.id].data" :comment="comment" />
        <div class="button-wrap">
          <button class="show-more-comment" v-if="commentaries[post.id].showMoreButton" @click.stop="showCommentsHandler">
            Загрузить еще
          </button>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  import PostHeader from './postHeader.vue';
  import PostBody from './postBody.vue';
  import PostComment from './postComment.vue';
  import PostRepost from './postRepost.vue';
  import PostReComment from './postReComment.vue';
  import { getCommentsApi } from '../../../../api/posts';

  export default {
    name: 'PostFull',
    components: {
      PostReComment,
      PostRepost,
      PostComment,
      PostBody,
      PostHeader,
    },
    props: {
      post: {
        type: Object
      },
    },
    data() {
      return {
        showComments: false,
        showMoreComments: false,
        commentaries: {},
        count: 0,
        start: 0,
        limit: 30,
        showButton: true,
        titles: [' Комментарий', ' Комментария', ' Комментариев'],
      };
    },
    methods: {
      printPost() {
        let post = document.querySelector('#print-post');
        let prtCSS =
          `<style>
            .post-controls {
              display: none;
              position: relative;
            }
            .post-counters {
                position: absolute;
                bottom: 0;
                left: 0;
                width: 100%;
                display: flex;
                align-items: center;
                padding: 10px 15px;
                box-sizing: border-box;
                border-top: 1px solid #e5e5e5;
                margin-bottom: 10px;
              }

              .post-body .post-counters {
                position: relative;
                border-bottom: 1px solid #e5e5e5;
              }

              .post-counter__item {
                display: flex;
                align-items: center;
                margin-right: 10px;
              }

              .post-counter__item:last-child {
                margin-right: 0;
              }

              .post-counter__item-icon {
                margin-right: 5px;
              }

              .post-counter__item-count {
                font-style: normal;
                font-weight: normal;
                font-size: 10px;
                line-height: normal;

                color: #55626F;
              }
              .counter-header__icon {
                width: 15px;
                height: 15px;
                position: relative;
                margin: 0 20px 0 -18px;
              }

              .tonal-indicator {
                position: absolute;
                overflow: hidden;
                top: 0;
                right: 0;
                width: 40px;
                height: 40px;
              }

              .tonal-indicator__netural::before {
                display: block;
                position: absolute;
                top: -20px;
                right: -20px;
                width: 40px;
                height: 40px;
                background-color:  #d8e1e9;
                transform: rotate(-45deg);
                content: '';
              }

              .tonal-indicator__positive::before {
                display: block;
                position: absolute;
                top: -20px;
                right: -20px;
                width: 40px;
                height: 40px;
                background-color: #03bb9a;
                transform: rotate(-45deg);
                content: '';
              }

              .tonal-indicator__negative::after {
                display: block;
                position: absolute;
                top: -20px;
                right: -20px;
                width: 40px;
                height: 40px;
                background-color: #ed002b;
                transform: rotate(-45deg);
                content: '';
              }

              .post-header__user-icon {
                width: 50px;
                height: 50px;
                border-radius: 50%;
                margin-bottom: 10px;
              }
          </style>`;
        let WinPrint = window.open('','','left=50,top=50,width=800,height=640,toolbar=0,scrollbars=1,status=0');
        WinPrint.document.write(prtCSS);
        WinPrint.document.write(post.innerHTML);

        setTimeout(function() {
          WinPrint.document.close();
          WinPrint.focus();
          WinPrint.print();
          WinPrint.close();
        }, 3000);

      },
      getTonalClass({ trust }) {
        if(trust){
          if (trust.trust === null || trust.trust === 0) {
            return 'tonal-indicator__netural';
          }

          if (trust.trust > 0) {
            return 'tonal-indicator__positive';
          }
        }
        return 'tonal-indicator__negative';
      },
      declOfNum(number){
        let cases = [2, 0, 1, 1, 1, 2];
        return this.titles[ (number%100>4 && number%100<20)? 2 : cases[(number%10<5)?number%10:5] ];
      },
      showCommentsHandler() {
        const id = this.post.id;
        const params = this.setParams(id);
        getCommentsApi(params)
          .then((resp) => {
            this.commentaries[id].data = [...this.commentaries[id].data, ...resp.data.commentaries];
            this.commentaries[id].count = this.commentaries[id].data.length;
            this.commentaries[id].start = this.commentaries[id].data.start;

            let restComments = parseInt(resp.data.count, 10) - this.commentaries[id].count;
            if (this.commentaries[id].count < this.limit || (this.commentaries[id].count + restComments) === parseInt(resp.data.count, 10)) {
              this.commentaries[id].showMoreButton = false;
            }
          });
      },
      showCommentsAction() {
        const id = this.post.id;
        if (!this.commentaries[id]) {
          const params = this.setParams(id);
          this.showButton = true;

          getCommentsApi(params)
            .then((resp) => {
              this.$set(this.commentaries, id, {
                data: resp.data.commentaries,
                count: resp.data.commentaries.length,
                start: resp.data.commentaries.length,
                showMoreButton: true,
                showComments: true
              });

              if(this.commentaries[id].data.length){
                this.showButton = false;
              }

              if (this.commentaries[id].count < this.limit || this.commentaries[id].count === parseInt(resp.data.count, 10)) {
                this.commentaries[id].showMoreButton = false;
              }
            });
        }
      },
      setParams(id) {
        return {
          limit: 30,
          network_id: this.post.network_id,
          owner_id: this.post.owner_id,
          post_id: id,
          start: this.commentaries[id] ? this.commentaries[id].start : 0,
          thread_id: this.$route.params.id,
        }
      },
    },
    watch: {
      post(){
        this.showCommentsAction();
      }
    },
  };
</script>

<style lang="stylus" scoped>
.post
  display flex
  flex-direction column
  padding 0
  margin 0
  background-color #ffffff
  &-comments
    border: none
    width 100%
    margin-top 5px
    padding 1em 0
    &-count
      display flex
      justify-content space-between
      align-items center
      width 100%
      font-family: "Oswald", "Arial", sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 23px;
      letter-spacing: 0.07em;
      text-transform: uppercase;
      color: #55626F;
      margin-bottom 1em
      &__icon
        width 1.4em
        hieght 1.4em
        margin 0 1em 0 0
      &__show
        font-family: "Oswald", "Arial", sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 23px;
        text-decoration none
        text-transform lowercase
        color: #55626F;
        cursor pointer
      &__show-more
        display inline-block
        margin-left 1em
        font-weight bold
        color #55626F
        cursor pointer
  .post-footer
    display flex
    flex-direction column
    justify-content flex-end
    align-items center
    .to-original
      margin-right 15px;
      font-size 12px
      color #55626F
      text-decoration none
.button-wrap
  width 100%
  padding 15px
  display flex
  justify-content center
  font-family: "Oswald", "Arial", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 23px;
  text-decoration none
  .show-more-comment
    margin-right 20px
    padding 5px 10px
    font-family: "Oswald", "Arial", sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 23px;
    border none;
    outline none;
    text-transform uppercase;
    background-color #0084ff;
    color #ffffff;
    cursor pointer;

.post-controls {
  margin-left auto
}

.to-original,
.to-original:hover,
.to-original:active,
.to-original:visited {
  font-family: "Oswald", "Arial", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 23px;
  text-decoration none
  color: #55626F;
}

.to-print,
.to-print:hover,
.to-print:active,
.to-print:visited {
  margin-right 10px
  font-family: "Oswald", "Arial", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 23px;
  text-decoration none
  color: #55626F;
  cursor pointer
}

.post-comments-count__show:first-letter {
  text-transform uppercase
}

.tonal-indicator
  position absolute
  overflow hidden
  top: 0
  right 0
  width 40px
  height 40px
.tonal-indicator__netural::before
  display block
  position absolute
  top -20px
  right -20px
  width: 40px
  height: 40px
  background-color  #d8e1e9
  transform rotate(-45deg)
  content ''
.tonal-indicator__positive::before
  display block
  position absolute
  top -20px
  right -20px
  width: 40px
  height: 40px
  background-color #03bb9a
  transform rotate(-45deg)
  content ''
.tonal-indicator__negative::after
  display block
  position absolute
  top -20px
  right -20px
  width: 40px
  height: 40px
  background-color #ed002b
  transform rotate(-45deg)
  content ''
</style>
